import { Block } from '@shared/models';

export const listingPagesFiltreMock: Block<null> = {
  type: 'listing-pages-filtre',
  data: null,
};
